// Fetch TopoJSON (browser auto-decompresses .br)
export async function loadTopojson(url: string) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to load ${url}`);
  const data = await res.json();
  if (data?.type === "Topology" && data?.objects) {
    const { feature } = await import("topojson-client");
    const firstKey = Object.keys(data.objects)[0];
    if (!firstKey) return data;
    return feature(data, data.objects[firstKey]);
  }
  return data;
}
